import { _ } from '@ngx-translate/core';

import { CardItem } from './types';

export const CARD_ITEMS: Array<CardItem> = [
  {
    type: 'display',
    title: _('components.lpStatisticsCard.constants.cardItems.display'),
    icon: '@tui.search',
  },
  {
    type: 'view',
    title: _('components.lpStatisticsCard.constants.cardItems.views'),
    icon: '@tui.eye',
  },
  {
    type: 'click',
    title: _('components.lpStatisticsCard.constants.cardItems.clicks'),
    icon: '@tui.external-link',
  },
  {
    type: 'discount',
    title: _('components.lpStatisticsCard.constants.cardItems.discounts'),
    icon: '@tui.circle-check',
  },
  {
    type: 'contact',
    title: _('components.lpStatisticsCard.constants.cardItems.contacts'),
    icon: '@tui.user',
  },
  {
    type: 'product',
    title: _('components.lpStatisticsCard.constants.cardItems.products'),
    icon: '@tui.bar-chart',
  },
];
